module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB4003-fa8164d40d295a2fc2f8db138124e182.png";